import { ConfigQuery } from '../generated/operations';
import { CountriesEnum, RegionsEnum } from '../generated/operations';
import { getDefaultCountry } from './getDefaultCountry';

export function getCountrySettings(
  config: ConfigQuery | null,
  currentCountry: CountriesEnum,
  currentRegion: RegionsEnum,
) {
  if (config === null) {
    return null;
  }
  const currentCountryData = config.countries
    .find((item) => item.code === currentCountry);
  if (currentCountryData) {
    return currentCountryData.data;
  }
  const defaultCountryCode = getDefaultCountry(currentRegion);
  const defaultCountry = config.countries
    .find((item) => item.code === defaultCountryCode);
  if (defaultCountry) {
    return defaultCountry.data;
  }
  return null;
}
